import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Indicador de carga reutilizable
 * 
 * @param {Object} props
 * @param {string} props.contentType - Tipo de contenido que se está cargando (imagen, video, etc.)
 * @param {boolean} props.isLoading - Estado que indica si está cargando
 * @param {string} props.color - Color del indicador (primary, secondary, inherit, etc.)
 * @param {number} props.size - Tamaño del indicador
 * @param {string} props.textColor - Color del texto
 */
const LoadingIndicator = ({ 
    contentType = 'contenido',
    isLoading = true,
    color = 'primary',
    size = 30,
    textColor = 'text.secondary'
}) => {
    if (!isLoading) return null;
    
    return (
        <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 1,
            zIndex: 2
        }}>
            <CircularProgress size={size} color={color} />
            <Typography variant="caption" color={textColor}>
                Cargando {contentType}...
            </Typography>
        </Box>
    );
};

export default LoadingIndicator;